// extracted by mini-css-extract-plugin
export default {"recipe":"recipe_recipe__McNtP","image":"recipe_image__LgPfr"};